import styled from 'styled-components';
import { THEME } from '@/common/styles/theme';

export const DeleteModalBackdrop = styled.div`
	position: fixed;
	inset: 0;
	z-index: 1200;
	display: grid;
	place-items: center;
	padding: 24px;
	background: rgba(8, 4, 14, 0.72);
	backdrop-filter: blur(6px);
`;

export const DeleteModalCard = styled.div`
	width: min(100%, 420px);
	padding: 24px;
	border-radius: 18px;
	border: 1px solid rgba(246, 142, 255, 0.18);
	background: linear-gradient(
		160deg,
		rgba(34, 16, 44, 0.96),
		rgba(18, 8, 28, 0.98)
	);
	box-shadow: 0 24px 60px rgba(0, 0, 0, 0.45);
`;

export const DeleteModalTitle = styled.h2`
	margin: 0 0 10px;
	font-family: ${THEME.fontDisplay};
	font-size: 1.35rem;
	color: ${THEME.text};
`;

export const DeleteModalText = styled.p`
	margin: 0 0 22px;
	color: rgba(216, 189, 228, 0.9);
	line-height: 1.5;
`;

export const DeleteModalActions = styled.div`
	display: flex;
	justify-content: flex-end;
	gap: 10px;
`;

const modalButton = styled.button`
	border: 0;
	border-radius: 999px;
	padding: 10px 18px;
	font-weight: 600;
	cursor: pointer;
	transition: opacity 0.2s ease;

	&:disabled {
		opacity: 0.55;
		cursor: not-allowed;
	}
`;

export const DeleteModalDismiss = styled(modalButton)`
	color: rgba(255, 245, 255, 0.9);
	background: rgba(255, 255, 255, 0.08);
`;

export const DeleteModalConfirm = styled(modalButton)`
	display: inline-flex;
	align-items: center;
	justify-content: center;
	gap: 8px;
	min-width: 108px;
	color: #fff;
	background: ${({ $success }) => (
		$success
			? 'linear-gradient(135deg, #3ecf8e, #2aab6f)'
			: 'linear-gradient(135deg, #ff5c7a, #d94b8f)'
	)};
	transition: background 0.25s ease, opacity 0.2s ease;

	&:disabled {
		opacity: ${({ $success }) => ($success ? 1 : 0.55)};
	}
`;

export const DeleteModalConfirmSpinner = styled.span`
	width: 14px;
	height: 14px;
	border: 2px solid rgba(255, 255, 255, 0.35);
	border-top-color: #fff;
	border-radius: 50%;
	animation: deleteModalConfirmSpin 0.7s linear infinite;
	flex-shrink: 0;

	@keyframes deleteModalConfirmSpin {
		to {
			transform: rotate(360deg);
		}
	}
`;
